export const oneOnOneSelector = state => state.oneOnOne;
